{"id":"Modal.CloseButton","prefabs":{"default":{"children":[{"component":"Modal.CloseButton","options":"options:*"}]}}}